import {useState} from "react";

function Api(){
    const [data, setData] = useState([]);
    fetch('http://www.omdbapi.com/?s={search}&apikey=9d9e1beb').then(
        response => response.json()
    ).then(value => setData(value.Search))

    return(
        <>
            <div className="container">
                <div className="row">
                    {data.map(movies =>
                        <>
                            <div className="col-md-4 mt-5 mb-3">
                                <div className="card">
                                    <img src={movies.Poster} className="card-img-top" alt="..." height="700px"/>
                                    <div className="card-body">
                                        <h5 className="card-title fs-4 cardHead">{movies.Title}</h5>
                                        <p className="card-text aboutText">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                        {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}
export default Api;